import { PropsWithChildren } from "react";

export function Card({ children }: PropsWithChildren) {
  return (
    <div className={"space-y-8 bg-white p-4 rounded-lg"}>
      {children ?? null}
    </div>
  );
}
